<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Phiếu chuyển hàng</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<!--<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">-->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label">Loại hàng <span class="text-danger">*</span>: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn loại hàng`"
						v-model="product"
						name="product"
						:options="$store.state.moduleProduct.products"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Loại hàng'"
						v-validate="'required'"
						required="true"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('product')">{{ errors.first("product") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Ngày giao
						<span class="text-danger">*</span>:
					</label>
					<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="shipping_date" :data-vv-as="'Thời gian'" class="w-full" v-model="shipping_date" type="date" placeholder="Chọn ngày giao" :picker-options="pickerOptions" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('shipping_date')">{{ errors.first("shipping_date") }}</span>
				</div>

				<fieldset class="fieldset-custom mb-5">
					<legend>Thông tin các phiếu chuyển hàng:</legend>
					<vs-row>
						<vs-col vs-lg="9" vs-sm="8" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									&nbsp;
								</label>
								<v-select
									:clearable="false"
									class="border-none w-full"
									:placeholder="`Chọn nhà cung cấp`"
									v-model="loaica"
									name="supplier"
									:options="loaicas"
									:reduce="(p) => p.id"
									label="name"
									:data-vv-as="'Nhà cung cấp'"
									v-validate="'required'"
									required="true"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="3" vs-sm="4" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label" style="display: block;">
									&nbsp;
								</label>
								<vs-button class="font-bold" @click.stop="themLoaiCa" >Thêm vào</vs-button>
							</div>
						</vs-col>
					</vs-row>

					<fieldset class="fieldset-custom mb-5" :key="indexLoaica" v-for="(itemLoaica, indexLoaica) in loaicaDaChon.slice().reverse()">
						<legend>{{ itemLoaica.name }}:</legend>
						<i
							class="actions__item el-icon-delete icon-custom"
							:title="$t('Actions.Delete')"
							@click="removeLoaicaDaChon(indexLoaica)"
						/>

						<vs-row>
							<vs-col vs-lg="3" vs-sm="3" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full">
									<label for class="text-base vs-input--label">
										Khối lượng
									</label>
									<CbsMaskedInput
										dataType="int"
										class="vs-inputx vs-input--input normal"
										:userSetting="{}"
										v-model.number="itemLoaica.khoi_luong"
									/>
								</div>
							</vs-col>
							<vs-col vs-lg="3" vs-sm="4" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pl-2">
									<label for class="text-base vs-input--label">
										Số xe
									</label>
									<cbs-input type="text" class="w-full" :placeholder="'Nhập số xe'" v-model="itemLoaica.so_xe"/>
								</div>
							</vs-col>
							<vs-col vs-lg="6" vs-sm="5" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full pl-2">
									<label for class="text-base vs-input--label">
										Người giao
									</label>
									<cbs-input type="text" class="w-full" :placeholder="'Nhập số xe'" v-model="itemLoaica.tai_xe"/>
								</div>
							</vs-col>
						</vs-row>
					</fieldset>
				</fieldset>
			</div>
		</div>
		<!--</PerfectScrollbar>-->

		<div class="flex justify-center" slot="footer" v-if="id == 0">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Lưu lại</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import CbsMaskedInput from "@/components/cbs-masked-input/CbsMaskedInput";
import moment from "moment";

const CAC_LOAI_CA = [];
export default {
	name: "ThuNganForm",
	components: { vSelect, CbsDatePicker, CbsMaskedInput, },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			loaicas: _.cloneDeep(CAC_LOAI_CA),
			loaica: null,
			loaicaDaChon: [],
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() <= Date.now();
				}
			},
			id: 0,
			product: 34,
			shipping_date: moment().format('YYYY-MM-DD'),
			data_props: {},
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;
			const { properties = [], id = 0 } = this.data;
			this.loaicas = this.$store.state.moduleProduct.suppliers;
			if (Array.isArray(properties) && properties.length) {
				this.loaicaDaChon = properties;
			} else {
				this.loaicaDaChon = [];
			}
			this.id = id;
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
			};
		},
	},
	created() {
		this.getSuppliers();
		
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_view = false, shipping_can_rating = false } = permissions;
			if (shipping_can_view) {
				this.canView = true;
			}
			if (shipping_can_rating) {
				this.canRating = true;
			}
			this.userToken = token;
		}
	},
	methods: {
		removeLoaicaDaChon(index) {
			this.loaicaDaChon.splice(index, 1);
		},
		themLoaiCa() {
			let loaicaDaChon = _.cloneDeep(this.loaicaDaChon);
			let loaicas = _.cloneDeep(this.loaicas);
			let loaiCaObj = loaicas.find(o => o.id == this.loaica);
			if (loaiCaObj) {
				loaiCaObj.khoi_luong = 0;
				loaiCaObj.so_xe = null;
				loaiCaObj.tai_xe = null;
				loaicaDaChon.push(loaiCaObj);
				let index = loaicas.findIndex(x => x.id == loaiCaObj.id);
				if (index >= 0) {
					loaicas.splice(index, 1);
					this.loaicas = loaicas;
				}
				this.loaicaDaChon = loaicaDaChon;
				this.loaica = null;
			}

		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			let properties = [];
			this.loaicaDaChon.forEach((loaiCaObj) => {
				properties.push({
					id: loaiCaObj.id,
					name: loaiCaObj.name,
					khoi_luong: loaiCaObj.khoi_luong,
					so_xe: loaiCaObj.so_xe,
					tai_xe: loaiCaObj.tai_xe,
				});
			});
			const dataObj = {
				id: this.id,
				properties: properties,
				product_id: this.product,
				shipping_date: this.shipping_date,
			};

			this.handleCreateOrUpdate(dataObj);
		},
		handleCreateOrUpdateSuccess() {
			// if (this.supplier == 0) {
			// 	this.getSuppliers();
			// }
			// if (!this.id) {
			// 	this.initValues();
			// }
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Lưu thành công",
				},
			});

			this.loaicas = _.cloneDeep(CAC_LOAI_CA);
			this.loaicaDaChon = [];
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/saveSo", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log(error);
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>


<style>
 .fieldset-custom {
	padding: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
	position: relative;
 }
 .icon-custom {
	position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
	cursor: pointer;
 }
@media only screen and (max-width: 600px) {
	.hide-on-mobile {
		display: none !important;
	}
}
</style>